import { Header } from '../Analysis/Header';

export const NewNotificationsLayout = ({ ...props }): JSX.Element => {
  const links = [
    {
      title: 'Feed',
      link: '/alertas/feed',
    },
    {
      title: 'Histórico',
      link: '/alertas/historico',
    },
    {
      title: 'Gerenciamento',
      link: '/alertas/gerenciamento',
    },
  ];

  return (
    <Header links={links} />
  );
};
